import React from "react";

const NoPermissionMessage = ({ className, action = "view", section = "this section" }) => {
    return (
        <div
            className={`${className}`}
            style={{
                padding: "1rem",
                color: "#d32f2f",
                borderRadius: "8px",
                fontSize: "1rem",
                textAlign: "center",
                marginTop: "1rem",
            }}
        >
            You do not have permission to view this section.
        </div>
    );
};

export default NoPermissionMessage;
